import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { Button } from '../controls';
import classes from './ErrorBox.module.scss';

export default function ErrorBox({
  error,
  children,
  className,
  ...rest
}: {
  error?: Error;
} & BoxProps) {
  if (!error && !children) {
    return null;
  }

  return (
    <Box className={clsx(classes.root, className)} {...rest}>
      <Typography className={classes.title} variant="h5">
        Error
      </Typography>

      {children && <div className={classes.children}>{children}</div>}

      {error && <div className={classes.error}>{error.message}</div>}
      {error && <pre className={classes.stack}>{error.stack}</pre>}

      <div className={classes.contact}>
        Try to{' '}
        <Button
          icon="redo"
          onClick={() => window.location.reload()}
          type="context"
          variant="text"
        >
          refresh the page
        </Button>
        or contact Pulse Admin
      </div>
    </Box>
  );
}
